import { render, staticRenderFns } from "./FloatLabelInput.vue?vue&type=template&id=9c48bfba&scoped=true&"
import script from "./FloatLabelInput.vue?vue&type=script&lang=ts&"
export * from "./FloatLabelInput.vue?vue&type=script&lang=ts&"
import style0 from "./FloatLabelInput.vue?vue&type=style&index=0&id=9c48bfba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c48bfba",
  null
  
)

export default component.exports